import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../component/common/Header";
import CONSTANT from "../../constant";
import { getCookie, onChange, setValue } from "../../utils";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AddCircular, AddCircularAttachment } from "../../actions/Circular";
import constant from "../../constant";
import Loader from "../../component/common/Loader";
import {
  addPropertyReturn,
  getPropertyReturnList,
  updatePropertyReturn,
} from "../../actions/property_retrun";
import moment from "moment";

export default class EmpPropertyReturn extends Component {
  constructor(props) {
    super(props);
    const userDetail = getCookie(CONSTANT.cookie.userDetail);
    this.state = {
      yearofProperty: {
        name: "yearofProperty",
        value: "",
        error: "",
        isRequired: true,
      },
      Uploads: {
        name: "Uploads",
        value: [],
        error: "",
        isRequired: true,
        touched: false,
      },
      userDetail,
      list: undefined,
      showLoader: false,
      formSubmitted: false,
      isEdit: false,
      upload_file_name:null,
      file_url:null,
      editId: null,
    };

    this.onChange = this.onChange.bind(this);
    this.PropertyReturnFormModel = this.PropertyReturnFormModel.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onFileBlur = this.onFileBlur.bind(this);
    this.successMessage = this.successMessage.bind(this);
    this.erroMessage = this.erroMessage.bind(this);
  }

  componentDidMount() {
    getPropertyReturnList()
      .then((data) => {
        this.setState({ list: data.result || [] });
      })
      .catch((error) => {
        console.error("Failed to fetch property return list:", error);
      });
  }

  resetForm = () => {
  this.setState({
    yearofProperty: {
      ...this.state.yearofProperty,
      value: "",
      error: "",
    },
    Uploads: {
      ...this.state.Uploads,
      value: [],
      error: "",
      touched: false,
    },
    formSubmitted: false,
    isEdit: false,
    upload_file_name: null,
    file_url: null,
    editId: null,
  });
};


  handleEdit = (item) => {
    this.setState({
      isEdit: true,
      editId: item.id, // or item.property_return_id (use correct key)
      upload_file_name:item.file_name,
      file_url:item?.file_url,
      yearofProperty: {
        ...this.state.yearofProperty,
        value: item.year_of_property,
        error: "",
      },

      // Reset file input (user must upload again)
      Uploads: {
        ...this.state.Uploads,
        value: [],
        error: "",
        touched: false,
      },
    });

    // Scroll to form (optional UX improvement)
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  PropertyReturnFormModel(state) {
    const { yearofProperty, Uploads } = state;

    const formData = new FormData();
    formData.append("yearOfProperty", yearofProperty.value);
    formData.append("attachment", Uploads.value[0]); // single PDF

    return formData;
  }

  async onSubmit(states) {
    const { yearofProperty, Uploads, isEdit, editId, file_url } = states;

    this.setState({ formSubmitted: true });

    // Validation
    if (!yearofProperty.value) {
      this.erroMessage("Please select a year");
      return;
    }

    if (Uploads.value.length === 0) {
      this.erroMessage("Please upload a PDF file");
      return;
    }

    this.setState({ showLoader: true });

    try {
      const model = this.PropertyReturnFormModel(this.state);

      let res;

      if (isEdit) {
        // 🔄 UPDATE MODE
        model.append("id", editId);
        model.append("file_url", file_url);
        res = await updatePropertyReturn(model);
      } else {
        // ➕ ADD MODE
        res = await addPropertyReturn(model);
      }

      if (res.status === constant.static.apiStatus.success) {
        this.successMessage(
          isEdit
            ? "Property updated successfully"
            : "Property uploaded successfully"
        );

        // Reset form after success
        this.setState({
          isEdit: false,
          editId: null,
          yearofProperty: {
            ...this.state.yearofProperty,
            value: "",
            error: "",
          },
          Uploads: {
            ...this.state.Uploads,
            value: [],
            error: "",
            touched: false,
          },
          formSubmitted: false,
        });

        // Reload list
        const listRes = await getPropertyReturnList();
        this.setState({ list: listRes.result || [] });
      } else {
        throw res.error;
      }
    } catch (err) {
      this.erroMessage(err || "Operation failed");
    } finally {
      this.setState({ showLoader: false });
    }
  }

  onChange(e) {
    const { name, value, files } = e.target;
    const { Uploads, yearofProperty } = this.state;

    if (name === Uploads.name && files) {
      // Reset error when files are selected
      this.setState({
        ...this.state,
        Uploads: {
          ...Uploads,
          value: files,
          error: "",
          touched: true,
        },
      });
    } else if (name === "financialYear") {
      // Handle year selection - map to yearofProperty
      this.setState({
        ...this.state,
        yearofProperty: { ...yearofProperty, value: value, error: "" },
      });
    } else {
      this.setState({
        ...this.state,
        [name]: { ...this.state[name], value: value, error: "" },
      });
    }
  }

  onFileBlur(e) {
    const { Uploads } = this.state;
    const { name } = e.target;

    if (name === Uploads.name) {
      this.setState({
        ...this.state,
        Uploads: { ...Uploads, touched: true },
      });
    }
  }

  onBlur(e) {
    const { name, value } = e.target;

    // Handle the year field blur (which has name="financialYear" in the select)
    if (name === "financialYear") {
      const { yearofProperty } = this.state;
      if (yearofProperty.isRequired && !value) {
        this.setState({
          ...this.state,
          yearofProperty: { ...yearofProperty, error: "Year is required" },
        });
      }
    }
    // For other fields that might be added later
    else {
      const field = this.state[name];
      if (field && field.isRequired && !value) {
        this.setState({
          ...this.state,
          [name]: { ...field, error: "This field is required" },
        });
      }
    }
  }

  dltItem = (index, array) => {
    const { Uploads } = this.state;
    const newArray = [...array];
    newArray.splice(index, 1);

    // Update the Uploads value
    const dt = new DataTransfer();
    newArray.forEach((file) => dt.items.add(file));
    const fileList = dt.files;

    this.setState({
      ...this.state,
      Uploads: {
        ...Uploads,
        value: fileList,
        error: fileList.length === 0 ? "At least one PDF file is required" : "",
        touched: true,
      },
    });
  };

  render() {
    const { showLoader, yearofProperty, Uploads, formSubmitted, list } =
      this.state;

    // Determine if file input should show error
    const showFileError =
      (Uploads.touched || formSubmitted) &&
      (Uploads.value.length === 0 || Uploads.error);

    // Determine the class for file input
    const fileInputClass = showFileError
      ? "form-control is-invalid"
      : "form-control";

    return (
      <React.Fragment>
        {showLoader && <Loader />}

        <div className="container-fluid">
          <div className="row">
            {/* <div className="col-md-2 px-0">
              <Header />
            </div> */}
            <div className="col-md-12">
              <div className="card homedob p-4 mb-4">
                <div className="row">
                  <div className="col-md-8">
                    <h3 className="page-title">Add Property</h3>
                  </div>

                  <div className="col-md-4 text-end">
                    <Link
                      to={CONSTANT.component.userFileList.url}
                      className="btn-back-home"
                    >
                      <h2> Go Back </h2>
                    </Link>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 mt-3">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-4">
                          <label>Select Year *</label>
                          <select
                            name="financialYear"
                            value={yearofProperty.value}
                            onChange={(e) => this.onChange(e)}
                            onBlur={this.onBlur}
                            className={
                              yearofProperty.error
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            required
                          >
                            <option value="">Select Year</option>
                            <option value="2025">2025</option>
                          </select>
                          {yearofProperty.error && (
                            <div className="invalid-feedback d-block">
                              {yearofProperty.error}
                            </div>
                          )}
                        </div>
                        <div className="col-md-4">
                          <label>Attachments * (PDF only)</label>
                          <input
                            type="file"
                            multiple
                            accept=".pdf,application/pdf"
                            className={fileInputClass}
                            placeholder="files"
                            name={Uploads.name}
                            onChange={(e) => this.onChange(e)}
                            onBlur={(e) => this.onFileBlur(e)}
                          />
                          {showFileError && (
                            <div className="invalid-feedback d-block">
                              {Uploads.error ||
                                "Please upload at least one PDF file"}
                            </div>
                          )}
                          <small className="form-text text-primary pl-1">
                            Only PDF files are allowed
                          </small>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <button
                              onClick={() => this.onSubmit(this.state)}
                              className="btn btn-block submit-button btn-sm mt-3 p-2"
                            >
                              {this.state.isEdit ? "Update" : "Submit"}
                            </button>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <button
                              onClick={() => this.resetForm()}
                              className="btn btn-block submit-button btn-sm mt-3 p-2"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {Array.from(Uploads.value).length > 0 && (
                      <div className="col-md-12 mt-3">
                        <span className="pr-3 fw-semibold">Selected File:</span>
                        {Array.from(Uploads.value).map((ele, index, array) => (
                          <span
                            key={index}
                            className="badge badge-primary mr-1 dlt_file mb-2 p-2"
                          >
                            {ele.name}
                            <i
                              onClick={() => {
                                this.dltItem(index, Array.from(Uploads.value));
                              }}
                              className="fa fa-times ml-2"
                              style={{ color: "white", cursor: "pointer" }}
                              aria-hidden="true"
                            />
                          </span>
                        ))}
                      </div>
                    )}

                    {this.state.editId && (
                      <div className="col-md-12 mt-3">
                        <span className="pr-3 fw-semibold">Uploaded File:</span>
                        <span
                          className="badge badge-primary mr-1 dlt_file mb-2 p-2"
                        >
                          {this.state.upload_file_name}
                        </span>
                      </div>
                    )}

                    {/* Show error message when no files are selected and form is submitted */}
                    {formSubmitted && Uploads.value.length === 0 && (
                      <div className="col-md-12 mt-2">
                        <div className="alert alert-danger py-2" role="alert">
                          Please upload at least one PDF file
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="row pt-4">
                    <div className="col-12">
                      {this.state.list && this.state.list.length > 0 ? (
                        <table className="table table-bordered">
                          <thead  className="head-bold">
                            <tr  className="font-bold">
                              <th>#</th>
                              <th>Year of Property</th>
                              <th>File Name</th>
                              <th>File URL</th>
                              <th>Created On</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.list.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item?.year_of_property}</td>
                                <td>{item?.file_name}</td>
                                <td>
                                  <a
                                    href={`${process.env.REACT_APP_BASE_URL}property_doc/${item.file_url}`.replace(
                                      "v1/",
                                      ""
                                    )}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {item?.file_url}
                                  </a>
                                </td>
                                <td>{moment(item?.created_at).format("DD-MM-YYYY")}</td>
                                <td>{item?.status}</td>
                                <td>
                                  {item?.status !== "APPROVED" && (
                                    <button
                                      className="btn btn-sm btn-primary"
                                      onClick={() => this.handleEdit(item)}
                                    >
                                      Edit
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        <div>No records found.</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    );
  }

  erroMessage(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }

  successMessage(message) {
    toast.success(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
}
